// extracted by mini-css-extract-plugin
export default {"content-error":"TableContent_content-error__J68Kc","content-loading":"TableContent_content-loading__N4XHR"};